import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { UseMutationResult, useQueryClient } from '@tanstack/react-query'
import { updateDynamicEmsSettings } from '../../api/dynamic-ems.api'
import { UpdateDynamicEmsSettingsModel } from '../../types'
import { usePortalMutation } from 'src/Libs/api'
import { dynamicEmsSettingsWithAvailabilityQueryKey } from '../use-dynamic-prices-settings'

type Variables = {
  installationId: string | undefined
} & UpdateDynamicEmsSettingsModel

interface UseUpdateDynamicEmsSettingsParams {
  onSuccess?: (vars: Variables) => void
  onError?: (vars: Variables) => void
}

type UseUpdateDynamicEmsSettingsReturnType = (
  data?: UseUpdateDynamicEmsSettingsParams
) => UseMutationResult<UpdateDynamicEmsSettingsModel | null, unknown, Variables>

const useUpdateDynamicEmsSettings: UseUpdateDynamicEmsSettingsReturnType = ({ onSuccess, onError } = {}) => {
  const authFetch = useAuthFetchWithResponse()
  const queryClient = useQueryClient()

  return usePortalMutation({
    mutationFn: ({ installationId, ...vars }: Variables) => updateDynamicEmsSettings(installationId, vars, authFetch),
    onSuccess: (_, vars) => {
      queryClient.invalidateQueries({ queryKey: dynamicEmsSettingsWithAvailabilityQueryKey(vars.installationId) })
      onSuccess?.(vars)
    },
    onError: (_, vars) => onError?.(vars),
  })
}

export default useUpdateDynamicEmsSettings
